export function beforeSave(record) {
  const newRecord = { ...record };

  newRecord.lines = record.lines
    .filter(({ id }) => id)
    .map(({ type, id }) => ({ type, id }));
  return newRecord;
}
